import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../assets/css/Footer.css';
import logo from '../assets/images/image.png';

function Footer() {
  // ... (كل كود الـ state و useEffect يبقى كما هو، لا تغيير)
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);


  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="footer-grid">

            {/* ... (عمود "عن الشركة" و "روابط مهمة" يبقون كما هم) ... */}
            <div className="footer-about">
              <img src={logo} alt="Peony Technologies Logo" className="footer-logo" />
              <p>
                شركة فلسطينية رائدة في تقديم الحلول البرمجية المبتكرة، ملتزمون بالجودة والإبداع لتحقيق أهداف عملائنا الرقمية.
              </p>
            </div>

            <div className="footer-links">
              <h4>روابط مهمة</h4>
              <ul>
                <li><Link to="/">الرئيسية</Link></li>
                <li><a href="/#about">من نحن</a></li>
                <li><a href="/#service">خدماتنا</a></li>
                <li><Link to="/careers">فرص العمل</Link></li>
                <li><a href="/#faq">الأسئلة الشائعة</a></li>
              </ul>
            </div>

            <div className="footer-contact">
              <h4>تواصل معنا</h4>
              <p>
                نابلس، فلسطين<br />
                {/* ! التعديل هنا: تم تغليف الرقم بـ span */}
                <strong>الهاتف:</strong> <span className="phone-number">+970 592 463 142</span><br />
                <strong>الإيميل:</strong> info@peony-technologies.com<br />
              </p>
              <div className="social-links">
                <a href="https://www.facebook.com/profile.php?id=61572511577563" target="_blank" rel="noopener noreferrer"><i className="ion-logo-facebook"></i></a>
                <a href="https://www.linkedin.com/company/peony-technologies" target="_blank" rel="noopener noreferrer"><i className="ion-logo-linkedin"></i></a>
                <a href="https://www.instagram.com/peony_technologies" target="_blank" rel="noopener noreferrer"><i className="ion-logo-instagram"></i></a>
                <a href="mailto:info@peony-technologies.com"><i className="ion-md-mail"></i></a>
              </div>
            </div>

          </div>
        </div>
      </div>



      {isVisible && (
        <button onClick={scrollToTop} className="back-to-top">
          <i className="ion-ios-arrow-up"></i>
        </button>
      )}
    </footer>
  );
}

export default Footer;